<template>
  <v-form v-model='formValid'>
    <v-row>
      <v-col cols='5'>
        <div class="mb-5">
          <img
            class="image-icon left"
            src="@/assets/icons/svg/pencil2.svg"
          />
          <span class="label-text">Name *</span>
          <div class="input-mb d-flex flex-nowrap">
            <v-text-field
              dense
              placeholder="Enter Name..."
              v-model="item.name"
              :rules="nameRules"
              color="#43425d"
              maxlength="128"
              class="r-field item-name-field"
            />
          </div>
        </div>
        <div class="mb-5">
          <img
            class="image-icon left"
            src="@/assets/icons/svg/pencil2.svg"
          />
          <span class="label-text">Notes</span>
          <div class="input-mb d-flex flex-nowrap">
            <v-textarea
              dense
              placeholder="Enter Note..."
              v-model="item.description"
              color="#43425d"
              maxlength="128"
              class="r-field item-name-field"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <div class="mb-5 table-wrapper mt-6 pa-4">
          <v-row class="table-controls px-3 mb-4 items-center">
            <v-menu
              class='select-warehouse-body'
              min-width='220'
              transition="slide-y-transition"
              :close-on-content-click='false'
              offset-y
              bottom
              right
              v-model='addingUserMenuState'
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  color='#8074c2'
                  class='px-4 text-white'
                >
                  Add users
                  <v-icon>
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <div class='bg-white pb-4'>
                <v-col
                  class='py-0 px-4'
                >
                  <v-text-field
                    v-model='searchUsersInput'
                    placeholder='Search...'
                    hide-details
                    autocomplete="off"
                    class='mt-0 pt-2'
                  />
                </v-col>
                <div class='to-selecting-list mt-2'>
                  <v-list
                    v-if='filtredUsersList.length'
                    max-height='150'
                  >
                    <v-list-item
                      v-for="(item, i) in filtredUsersList"
                      :key="i"
                      :class="{'v-list-item--active': item.active}"
                      style='min-height: 32px'
                    >
                      <v-list-item-title>
                        <div
                          class='flex items-center'
                        >
                          <v-simple-checkbox
                            v-model='item.selected'
                            color='#8074c2'
                            @input='handleChangeSelectedUsersList(item)'
                          />
                          <span class='ml-1 warehouse-list-title'>{{ item.firstName }} {{ item.lastName }}</span>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                  <p v-else class='px-2 py-1 text-center font-italic'>No Users Found</p>
                </div>
              </div>
            </v-menu>
            <v-spacer />
          </v-row>
          <v-divider class='row' />
          <v-row class="justify-space-between">
            <v-col cols="12" class="px-0">
              <v-data-table
                :headers="usersHeaders"
                :items="item.info.users"
                :page.sync="usersPage"
                :items-per-page="usersPerPage"
                item-key="id"
                hide-default-footer
                @page-count="usersPageCount = $event"
              >
                <template :slot='"no-results"'>
                  <p class="text-h6 my-16">No Users found</p>
                </template>
                <template :slot='"no-data"'>
                  <p class="text-h6 my-16">No Users found</p>
                </template>
                <template v-slot:[`item.selected`]>
                  <v-simple-checkbox
                    color="#7972c0"
                    :ripple="false"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  {{ item.createdAt | formatDate(getDateTimeFormat) }}
                </template>
                <template v-slot:[`item.lastVisit`]="{ item }">
                  {{ item.lastVisit | formatDate(getDateTimeFormat) }}
                </template>
                <template v-slot:[`item.inviteStatus`]="{ item }">
                        <span
                          v-if="$checkEqualityStrings(item.inviteStatus, 'accepted')"
                          style="
                            background-color: #d6f7e2;
                            color: #3d654d;
                            border-radius: 4px;
                          "
                          class="pa-1"
                        >
                          {{ item.inviteStatus }}
                        </span>
                  <span
                    v-else
                    style="
                            background-color: #fff1d6;
                            color: #b67501;
                            border-radius: 4px;
                          "
                    class="pa-1"
                  >
                          {{ item.inviteStatus }}
                        </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-row class="flex-nowrap">
                    <v-col cols="6" class="px-1" v-if='$getRight("userManagement") && !$checkEqualityStrings(item.inviteStatus, "owner")'>
                      <router-link class="ml-1" :to='{name: "EditUser", params: {id: item.id}}'>
                        <img
                          style="height: 16px; width: 16px"
                          src="@/assets/icons/svg/draw.svg"
                          title="Edit"
                        />
                      </router-link>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <img
                        v-if="$getRight('warehouseEdit') && item.inviteStatus !== 'owner'"
                        style="height: 16px; width: 16px"
                        src="@/assets/icons/svg/delete1.svg"
                        @click="deleteUser(item.id)"
                        class="cursor-point"
                        title="Delete"
                      />
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="pagination-wrapper">
            <v-col cols="5">
              <span class="text-nowrap mr-2">Items per page</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    style="padding: 0; font-weight: 600"
                  >
                    {{ usersPerPage }}
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in [5, 10, 20, 25, 50]"
                    :key="index"
                    link
                    @click="usersPerPage = item"
                  >
                    <v-list-item-title>{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="7" class="d-flex justify-end">
              <v-pagination
                v-model="usersPage"
                :length="usersPageCount"
                :total-visible="6"
                color="#7972C0"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class='flex justify-center align-center'>
        <v-btn
          color='#7972c0'
          depressed
          @click='validate'
        >
          <v-icon
            color='#ffffff'
          >
            mdi-plus
          </v-icon>
          <span class='text-white ml-2'>
            Create
          </span>
        </v-btn>
        <v-btn
          class='ml-2'
          depressed
          outlined
          color='#7972c0'
          @click='$emit("cancelWarehouseClick")'
        >
          <v-icon
            color='#7972c0'
          >
            mdi-close
          </v-icon>
          <span class='ml-2' style='color: #7972c0'>
            Cancel
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import service from '@/services/warehouses'

export default {
  name: 'syncStep1Adding',
  data: () => ({
    formValid: true,
    item: {
      name: '',
      description: '',
      active: true,
      info: {
        users: []
      }
    },
    nameRules: [
      v => !!v.length || 'Warehouse name is required'
    ],
    usersHeaders: [
      {
        text: 'First Name',
        align: 'start',
        sortable: true,
        value: 'firstName'
      },
      {
        text: 'Last Name',
        value: 'lastName',
        sortable: true,
        align: 'start'
      },
      { text: 'Role', value: 'role', sortable: true, align: 'start' },
      { text: 'Email', value: 'email', sortable: true, align: 'start' },
      {
        text: 'Phone Number',
        value: 'phone',
        sortable: true,
        align: 'start'
      },
      { text: 'Created', value: 'createdAt', sortable: true, align: 'start' },
      {
        text: 'Last Active',
        value: 'lastVisit',
        sortable: true,
        align: 'start'
      },
      {
        text: 'Status',
        value: 'inviteStatus',
        sortable: true,
        align: 'start'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'start'
      }
    ],
    usersPerPage: 5,
    usersPage: 1,
    usersPageCount: 0,
    searchUsersInput: '',
    addingUserMenuState: false
  }),
  computed: {
    ...mapGetters('user', ['getDateTimeFormat', 'invitedUsers']),
    filtredUsersList() {
      const usersFilter = users => {
        this.invitedUsers.forEach(item => {
          if (this.item.info.users.find(user => user.id === item.id)) {
            item.selected = true
          }
        })
        return users.filter(user => {
          return user.inviteStatus === 'accepted'
        })
      }
      if (this.searchUsersInput) {
        return usersFilter(this.invitedUsers.filter(item => {
          const name = `${item.firstName} ${item.lastName}`
          return name.toLowerCase().search(new RegExp(this.searchUsersInput.toLowerCase()), 'g') >= 0
        }))
      }
      return usersFilter(this.invitedUsers)
    }
  },
  filters: {
    formatDate: (v, format) => moment(v).format(format)
  },
  methods: {
    async validate() {
      const payload = this.item
      payload.info.users = this.item.info.users.map(item => ({ id: item.id, email: item.email }))
      const result = await service.addWarehouse(this.item)
      if (result?.data?.error?.type === 200) {
        this.$store.dispatch('warehouses/loadWarehousesList')
        this.$emit('selectWarehouse', {
          id: result.data.data.id,
          haveAdded: true
        })
        this.$emit('cancelWarehouseClick')
      }
    },
    deleteUser(id) {
      const users = this.item.info.users
      users.splice(users.findIndex(user => user.id === id), 1)
      this.invitedUsers.find(user => user.id === id).selected = false
    },
    handleDelete() {
      this.itemToDelete = null
      this.$router.back()
    },
    handleChangeSelectedUsersList(item) {
      if (item.selected) {
        delete item.selected
        this.item.info.users.push(item)
      } else {
        this.item.info.users.splice(this.item.info.users.findIndex(user => user.id === item.id), 1)
      }
    }
  }
}
</script>
